import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { IHelpNode } from './helpTree';
import { GuideIconTile } from './GuideIconTile';
import { EnglishOnlyPill } from './EnglishOnlyPill';
import { GuideCardHeader, GuideCardMeta } from './GuideCardParts';
import styles from './HelpCenterPage.module.css';

interface IParentGuideCardProps {
  node: IHelpNode;
  order: number;
}

export function ParentGuideCard({ node, order }: IParentGuideCardProps) {
  const { t } = useTranslation();
  const { guide, children } = node;
  const total = children.reduce((sum, child) => sum + child.minutes, 0);
  return (
    <div className={`${styles.card} ${styles.parentCard}`} style={{ order }} data-testid="parent-card">
      <Link to={`/help/${guide.slug}`} className={styles.parentMain}>
        <GuideCardHeader guide={guide} badge={<span className={styles.countBadge}>{t('help.reportGuides', { count: children.length })}</span>} />
        <p className={`${styles.cardSummary} ${styles.twoLines}`}>{guide.summary}</p>
      </Link>
      <div className={styles.kidsGrid}>
        {children.map((child) => (
          <Link key={child.slug} to={`/help/${child.slug}`} className={styles.kid}>
            <GuideIconTile iconKey={child.iconKey} variant="kid" />
            <span className={styles.kidText}>{child.title}<small>{t('help.minRead', { count: child.minutes })}</small></span>
            <EnglishOnlyPill language={child.language} />
          </Link>
        ))}
      </div>
      <GuideCardMeta
        first={t('help.hubGuide', { count: guide.minutes })}
        second={t('help.allReports', { count: total })}
        updatedAt={guide.updatedAt}
        className={styles.parentMeta}
      />
    </div>
  );
}
